var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultChecboxSeletection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.31921,
    width: 19,
    height: 19,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.31921,
    width: 19,
    height: 19,
    rx: 5.5,
    stroke: "#D1D1D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultChecboxSeletection);
export default __webpack_public_path__ + "static/media/defaultChecboxSeletection.8a0d390c530fdbc4977bf10340aca426.svg";
export { ForwardRef as ReactComponent };